import { render, staticRenderFns } from "./OrgDemandsByAttorney.vue?vue&type=template&id=ff1ed7d2&scoped=true&"
import script from "./OrgDemandsByAttorney.vue?vue&type=script&lang=js&"
export * from "./OrgDemandsByAttorney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1ed7d2",
  null
  
)

export default component.exports